import React, { useContext, useEffect, useState } from 'react';
import { ExamData, ExamDetails } from '../view/Private/Exam/context';
import EndExamConfirmation from './Modal/EndExamConfirmation';
import LiveExam from '../Services/liveexam.services';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import InfoMadal from './Modal/InfoMadal';
import Auth from '../auth/auth';
import { defaultTheme, Wordmark, UserChip, NxButton, NxIcon, Pill } from './nx';

const t = defaultTheme;

export default function NavBar() {
    const [showModal, setShowModal] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const examDetails: any = useContext(ExamDetails);
    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState<any>({
        student: { image: "", name: "", first_name: "" }
    });

    const getUserInfo = async () => {
        try {
            const res = await LiveExam.getUserInfo();
            if (res.status === 200) setUserInfo(res.data.data);
        } catch (e) {}
    };

    const handleExamSubmission = async () => {
        try {
            const res = await LiveExam.setExamStatusCompleted();
            if (res.status === 200) {
                toast.success("Exam Submitted");
                localStorage.removeItem("authKey");
                localStorage.removeItem("liveToken");
                navigate("/exam_submitted");
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => { getUserInfo(); }, []);

    function handleLogout() {
        Auth.signout();
        navigate("/login");
    }

    const studentName = userInfo?.student?.name || userInfo?.student?.first_name || 'User';
    const studentEmail = userInfo?.student?.email || '';

    return (
        <>
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                height: 56, padding: '0 24px',
                background: t.surface, borderBottom: `1px solid ${t.border}`,
                fontFamily: '"Geist", ui-sans-serif, system-ui, -apple-system, sans-serif',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <Wordmark t={t} compact />
                    <span style={{ height: 18, width: 1, background: t.border }} />
                    <div>
                        <div style={{ fontSize: 13, fontWeight: 500, color: t.ink, lineHeight: 1.1 }}>
                            {examDetails?.examDetail?.examName || "Loading..."}
                        </div>
                        <div style={{ fontSize: 11, color: t.inkMute, marginTop: 2 }}>
                            {examDetails?.examDetail?.subjects?.[0] || 'Exam'}
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
                    <a
                        onClick={() => setShowInfoModal(true)}
                        style={{ fontSize: 12, color: t.inkSoft, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
                    >
                        {NxIcon.info(t.inkSoft)} Instructions
                    </a>
                    <UserChip t={t} name={studentName} email={studentEmail} onLogout={handleLogout} />
                    <NxButton t={t} kind="primary" danger onClick={() => setShowModal(true)}>
                        Submit &amp; end
                    </NxButton>
                </div>
            </div>

            <EndExamConfirmation show={showModal} setShow={setShowModal} onSuccess={handleExamSubmission} />
            <InfoMadal show={showInfoModal} setShow={setShowInfoModal} />
        </>
    );
}
